import { gql } from '@apollo/client';

export default gql`
  mutation updateGeneralSettings(
    $banner: JSON
    $bannerHeight: Int
    $childrenDescriptionLabel: String
    $childrenNameLabel: String
    $childrenStatusLabel: String
    $cssOverwrite: String
    $customSubDomain: String
    $displayClonedActions: String
    $displayLevel: displayLevel
    $displayLinkedProjects: String
    $displayLowestLevelDates: Boolean
    $drilldownable: Boolean
    $enableIpList: Boolean
    $fontFamily: fontFamily
    $fontSize: String
    $footer: String
    $footerBackgroundColor: String
    $googleTracking: String
    $isA11yMode: Boolean
    $translateProvider: TranslateProvider
    $headerBackgroundColor: String
    $hideCustomFields: [Int]
    $hideTags: [Int]
    $horizontalPadding: String
    $ipWhiteList: [String]
    $logo: JSON
    $logoLink: String
    $measureColumns: measureColumns
    $navPosition: navPosition
    $navTextColor: String
    $notificationType: NotificationType
    $pageTitle: String
    $showChecklist: Boolean
    $showCompleted: Boolean
    $showCustomFields: Boolean
    $showDiscontinued: Boolean
    $showIndicatorOnHeader: Boolean
    $showLatestUpdate: Boolean
    $showLinkedProjectBudget: Boolean
    $showLinkedProjectExpenditure: Boolean
    $showLinkedProjectPhase: Boolean
    $showMajorDisruption: Boolean
    $showMeasureDetail: Boolean
    $showMinorDisruption: Boolean
    $showOnTrack: Boolean
    $showProgress: Boolean
    $showStatusBar: Boolean
    $showStatusPending: Boolean
    $showTags: Boolean
    $showUpcoming: Boolean
    $syncSettings: JSON
    $syncStartOn: String
    $syncStatus: Boolean
    $syncType: SyncType
    $userId: String
  ) {
    updateGeneralSettings(
      banner: $banner
      bannerHeight: $bannerHeight
      childrenDescriptionLabel: $childrenDescriptionLabel
      childrenNameLabel: $childrenNameLabel
      childrenStatusLabel: $childrenStatusLabel
      cssOverwrite: $cssOverwrite
      customSubDomain: $customSubDomain
      displayClonedActions: $displayClonedActions
      displayLevel: $displayLevel
      displayLinkedProjects: $displayLinkedProjects
      displayLowestLevelDates: $displayLowestLevelDates
      drilldownable: $drilldownable
      enableIpList: $enableIpList
      fontFamily: $fontFamily
      fontSize: $fontSize
      footer: $footer
      footerBackgroundColor: $footerBackgroundColor
      googleTracking: $googleTracking
      translateProvider: $translateProvider
      isA11yMode: $isA11yMode
      headerBackgroundColor: $headerBackgroundColor
      hideCustomFields: $hideCustomFields
      hideTags: $hideTags
      horizontalPadding: $horizontalPadding
      ipWhiteList: $ipWhiteList
      logo: $logo
      logoLink: $logoLink
      measureColumns: $measureColumns
      navPosition: $navPosition
      navTextColor: $navTextColor
      notificationType: $notificationType
      pageTitle: $pageTitle
      showChecklist: $showChecklist
      showCompleted: $showCompleted
      showCustomFields: $showCustomFields
      showDiscontinued: $showDiscontinued
      showIndicatorOnHeader: $showIndicatorOnHeader
      showLatestUpdate: $showLatestUpdate
      showLinkedProjectBudget: $showLinkedProjectBudget
      showLinkedProjectExpenditure: $showLinkedProjectExpenditure
      showLinkedProjectPhase: $showLinkedProjectPhase
      showMajorDisruption: $showMajorDisruption
      showMeasureDetail: $showMeasureDetail
      showMinorDisruption: $showMinorDisruption
      showOnTrack: $showOnTrack
      showProgress: $showProgress
      showStatusBar: $showStatusBar
      showStatusPending: $showStatusPending
      showTags: $showTags
      showUpcoming: $showUpcoming
      syncSettings: $syncSettings
      syncStartOn: $syncStartOn
      syncStatus: $syncStatus
      syncType: $syncType
      userId: $userId
    ) {
      banner {
        image
        position
      }
      bannerHeight
      billable
      childrenDescriptionLabel
      childrenNameLabel
      childrenStatusLabel
      completedCount
      cssOverwrite
      customFields {
        customFieldId
        fieldName
        fieldType
        numberDecimalRounding
        numberPrefix
        numberSuffix
        numberThousandSeparator
        planningStructureId
      }
      customSubDomain
      discontinuedCount
      displayClonedActions
      displayLevel
      displayLinkedProjects
      displayLowestLevelDates
      drilldownable
      enableIpList
      fontFamily
      fontSize
      footer
      footerBackgroundColor
      googleTracking
      isA11yMode
      translateProvider
      headerBackgroundColor
      hideCustomFields
      hideTags
      horizontalPadding
      ipWhiteList
      logo {
        image
      }
      logoLink
      majorDisruptionCount
      measureColumns
      name
      navPosition
      navTextColor
      notificationType
      onTrackCount
      overdueCount
      pageTitle
      progressPercentage
      reportingDates
      showChecklist
      showCompleted
      showCustomFields
      showDiscontinued
      showIndicatorOnHeader
      showLatestUpdate
      showLinkedProjectBudget
      showLinkedProjectExpenditure
      showLinkedProjectPhase
      showMajorDisruption
      showMeasureDetail
      showMinorDisruption
      showOnTrack
      showProgress
      showStatusBar
      showStatusPending
      showTags
      showUpcoming
      someDisruptionCount
      startOfFinancialYear
      statusPendingCount
      syncRequestedAt
      syncSettings {
        amPmGenerated
        autoSync
        frequency
        monthlyEachDates
        monthlyEvery
        monthlyMode
        monthlyOnTheDayOption
        monthlyOnTheFirstLastOption
        reportingDateBeforeAfter
        reportingDateDays
        syncType
        timeGenerated
        weeklyEvery
        weeklyOn
      }
      syncStartOn
      syncStatus
      tags {
        colorCode
        tagId
        tagName
        labelColor
      }
      timeZone
      timeZoneName
      upcomingCount
    }
  }
`;
